import { c as _c } from "react/compiler-runtime";
import { useToggle } from "@website/accommodation-ui/tour-search-box/tour-search-toggle/hooks";
import { TourSearchTogglePropertiesType } from "@website/accommodation-ui/tour-search-box/tour-search-toggle/types";
import { TourSearchPanelGroup } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/tour-search-panel";
import { TourSearchPanel } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/tour-search-panel";
import { TourSearchPanelPropertiesType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/types";
import { Badge } from "@website/ui/badge";
import { ToggleButton } from "@website/ui/toggle-button";
import { useRouter } from "next/router";
import { FC } from "react";
export const TourSearchToggle: FC<TourSearchTogglePropertiesType> = properties => {
  const $ = _c(9);
  const {
    pathname,
    query
  } = useRouter();
  const isGroup = query.tour === "tour-group" || pathname.includes("group") ? "tour-group" : "tour";
  const isHomePage = process.env.NEXT_PUBLIC_APP_NAME === "homepage";
  const {
    toggleList,
    toggleValue
  } = useToggle();
  let t0;
  if ($[0] !== toggleList || $[1] !== toggleValue) {
    t0 = isHomePage && <div className="relative lg:max-w-max lg:px-0"><ToggleButton className="mb-6" color="secondary" list={toggleList} size="small" value={toggleValue} variant="contained" /><div className="absolute -top-2 left-8 lg:left-4"><Badge content={"\u062C\u062F\u06CC\u062F"} /></div></div>;
    $[0] = toggleList;
    $[1] = toggleValue;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== isGroup || $[4] !== properties) {
    t1 = isGroup === "tour-group" ? <div className="size-full"><TourSearchPanelGroup {...properties} /></div> : <TourSearchPanel {...properties as TourSearchPanelPropertiesType} />;
    $[3] = isGroup;
    $[4] = properties;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t0 || $[7] !== t1) {
    t2 = <div className="h-full">{t0}{t1}</div>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};